module.exports = __webpack_public_path__ + "img/facts-teamstore.cab82bde.png";